import { TextField } from "@mui/material";

const PhoneNumberInput = ({ value, onChange, disabled, label, style }) => {

  const formatPhoneNumber = (input) => {
    // Remove all non-numeric characters except "+"
    let cleaned = input.replace(/[^\d]/g, "");

    // Hardcoded -- adds north american country code if not entered
    // change if international country codes needed
    if (cleaned.length > 0 && !cleaned.startsWith("1")) {
      cleaned = "1" + cleaned;
    }

    // Ensure it doesn't exceed 11 digits (including country code)
    if (cleaned.length > 11) return value;

    // Format the number
    let formatted = "+1";
    if (cleaned.length > 1) formatted += `-${cleaned.slice(1, 4)}`;
    if (cleaned.length > 4) formatted += `-${cleaned.slice(4, 7)}`;
    if (cleaned.length > 7) formatted += `-${cleaned.slice(7, 11)}`;

    return formatted;
  };

  const handleInputChange = (e) => {
    const rawInput = e.target.value;
    const formattedNumber = formatPhoneNumber(rawInput);
    onChange(formattedNumber);
  };

  return (
    <TextField
      label={label}
      value={value}
      onChange={handleInputChange}
      sx={style}
      disabled={disabled}
      placeholder="+1-XXX-XXX-XXXX"
    />
  );
};

export default PhoneNumberInput;